import { NextSeo } from 'next-seo';
import type { NextSeoProps } from 'next-seo';
import { useIsMobile } from '~/context/common/DeviceContext';
import {
  useGetSpinnerData,
  useGetVehicleDetails
} from '~/context/vdp/VehicleContext';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';

export default function HeadTags(props: Partial<NextSeoProps>) {
  const {
    year,
    make,
    model,
    mileage = 0,
    trim,
    price = 0,
    vehicleId,
    stockImageData
  } = useGetVehicleDetails();
  const { gif } = useGetSpinnerData();
  const isMobile = useIsMobile();

  const jellyBeanPreview = isMobile
    ? stockImageData?.jellyBeanMobileUrl
    : stockImageData?.jellyBeanDesktopUrl;
  const previewImage = gif || jellyBeanPreview;
  const imageType = gif ? 'image/gif' : 'image/png';
  const description = price
    ? `Used ${year} ${make} ${model} ${trim} for $${formatAndDropDecimal(
        price
      )} with ${mileage.toLocaleString()} miles. | Carvana`
    : `Used ${year} ${make} ${model} ${trim} with ${mileage.toLocaleString()} miles. | Carvana`;

  return (
    <NextSeo
      title={`Used ${year} ${make} ${model} | Carvana`}
      description={description}
      openGraph={{
        type: 'website',
        siteName: 'Carvana.com',
        title: `${year} ${make} ${model} - Carvana`,
        url: `${process.env.CVNA_APP_ABSOLUTE_BASE_URL}/vehicle/${vehicleId}`,
        description,
        images: previewImage
          ? [
              {
                url: `${previewImage}?width=600`,
                width: 600,
                height: 296,
                alt: `Used ${year} ${make} ${model} | Carvana`
              }
            ]
          : undefined
      }}
      additionalMetaTags={[
        {
          property: 'og:image:type',
          content: `${imageType}`
        }
      ]}
      {...props}
    />
  );
}
